module.exports = __webpack_public_path__ + "static/media/biking.fd885e80.svg";